import { Button, Modal, Input, Form, Select, message, Col, Row, DatePicker, Divider, Space, Radio, List, Skeleton } from 'antd';
import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import axios from 'axios';

import { requestError } from '../../controllers/functions';
import { PlusOutlined } from '@ant-design/icons';
import { useRef } from 'react';
import { useCallback } from 'react';
import { Link } from 'react-router-dom';
  const { Option } = Select;

const BackOfficeExpenseModal = ({ show, setOpenModal, record, action, refresh, extractTokenFromUrl }) => {

  const [form] = Form.useForm();
  const [expenseTypeForm] = Form.useForm();
  const inputRef = useRef(null);
  const [currencies, setCurrencies] = useState([]);
  
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [expenseTypes, setExpenseTypes ] = useState([]);
  const [expenseType, setExpenseType ] = useState({});
  const [loading, setLoading] = useState(false);

  const [state, setState] = useState({});
  
  if(show !== isModalVisible){
    setIsModalVisible(show);
  }

  const submit = (v) =>{

    const url = record?.id ?
      process.env.REACT_APP_API_URI+`/back/office/expenses/${record?.id}` :
      process.env.REACT_APP_API_URI+`/back/office/expenses`;

    axios.post(url, v , {headers: { authorization : `Bearer ${extractTokenFromUrl()}`}} ).then(res=>{
      message.success(res.data.res);
      if( v?.notCloseModal){
        form.resetFields();
      }else{
        setOpenModal(false);
      }
      refresh();
    }).catch(error=>{
      requestError({error});
    }).finally(done=>{
        setLoading(false);
    })
  }

const getApis = useCallback(async () => {
  try {
      const headers =  { authorization : `Bearer ${extractTokenFromUrl()}`};
      const [ expenseTypesData, currencesData ] = await Promise.all([
          axios.get(`${process.env.REACT_APP_API_URI}/back/office/expsense/types`, { headers }),
          axios.get(process.env.REACT_APP_API_URI+"/school/fees/currencies", { headers }),
      ]);
      setExpenseTypes(expenseTypesData.data);
      setCurrencies(currencesData.data);
  } catch (error) {
      requestError({ error });
  }
}, [extractTokenFromUrl]);

useEffect(() => {
    if(show){
        setState({...record});
        form.resetFields();
        form.setFieldsValue({...record});
        getApis()
    }
}, [form, getApis, record, show]);

const saveExpenseType = (v) => {

    const url = expenseType?.id ?
      process.env.REACT_APP_API_URI+`/back/office/expsense/types/${expenseType?.id}` :
      process.env.REACT_APP_API_URI+`/back/office/expsense/types`;
  
      axios.post(
          url, 
          v, 
          {headers: { authorization : `Bearer ${extractTokenFromUrl()}`}} 
      ).then( done => {
          setExpenseTypes([
            ...(expenseType?.id? expenseTypes.filter( x => x?.id !== expenseType?.id) : expenseTypes ) , 
            done.data?.expenseType 
          ]);
          setState({ ...state, expenseTypeId : done.data?.expenseType?.id })
          form.setFieldValue("expenseTypeId", done.data?.expenseType?.id )
          setExpenseType(null);
          setTimeout(() => {
          inputRef.current?.focus();
          }, 0);
          expenseTypeForm.resetFields();
      }).catch( error => {
          requestError({error});
      })
     
    };

  return (
    <>
      <Modal 
      title={'Add Expense' }
      open={isModalVisible} 
      onOk={()=>setOpenModal(false)} 
      onCancel={()=>setOpenModal(false)}
      footer={[
        <Button key="cancel" type=""  onClick={()=>{setOpenModal(false)}}>
            Cancel
        </Button>,
        <Button  key="submit" type="primary" htmlType="submit" form="studentexpenseForm" loading={loading}>
          Save 
        </Button> 
      ]}
      >
        <Divider />
        <Form
        layout="vertical"
        className="row-col"
        onFinish={ (v)=> submit(v) }
        id="studentexpenseForm" 
        form={form}
        > 
        <Row>
          <Col span={24}  >
            <Form.Item 
            style={{marginRight: 5}} name={'expenseTypeId'} label = "Select Expense Type" 
            rules={[
              { required: true, message: "Select Select Expense Type!" },
            ]}
            >
                  <Select className='m-0'
                    showSearch
                    value={state?.expenseTypeId}
                    onChange={(value)=>setState({ ...state, expenseTypeId : value })}
                    placeholder="Select Expense Type"

                    optionFilterProp="children"
                    filterOption={(input, option) =>
                        option?.label?.props?.children[0]?.props?.children
                        ?.toLowerCase()
                        .includes(input.toLowerCase())
                    }

                    popupRender={(menu) => (
                        <>
                          {menu}
                          <Divider style={{ margin: '8px 8px' }} />
                          <Form
                          form={expenseTypeForm}
                          id="backOfstudentexpenseTypeFormficeExpenseForm"
                          style={{ width: '100%', padding: '0 10px 10px 10px' }}>
                            <Row className='remove-antd-row-margin-expenseTypes' gutter={[8, 12]}>

                              <Col flex={"auto"}>
                                <Form.Item
                                  name="name"
                                  style={{ marginBottom: 5 }}
                                  rules={[{ required: true, message: "Enter Expense Type!" }]}
                                >
                                  <Input
                                    placeholder="Expense Type"
                                    style={{ height: 33 }}
                                    onKeyDown={(e) => e.stopPropagation()}
                                  />
                                </Form.Item>
                              </Col>
                              
                              <Col flex={"none"}>
                                <Form.Item
                                  name="name"
                                  style={{ marginBottom: 5 }}
                                >
                                  <Button
                                  type="primary"
                                  form="studentexpenseTypeForm"
                                  style={{ height: 33 }}
                                  onClick={() => {
                                      expenseTypeForm
                                        .validateFields()
                                        .then((values) => {
                                            saveExpenseType(values);
                                        })
                                        .catch((info) => {
                                            console.log('Validate Failed:', info);
                                        });
                                    }}
                                    >
                                        +
                                    </Button>

                                </Form.Item>
                              </Col>

                            </Row>
                            </Form>
                        </>
                    )}

                    options={expenseTypes.map((item) => ({
                        label: (
                        <Row align="middle" justify="space-between" style={{ margin : 0 }}>
                            <Col flex="auto">{item?.name}</Col>
                            <Col>
                            <Button
                                type="link"
                                onClick={(e) => {
                                    e.stopPropagation(); 
                                    expenseTypeForm.setFieldsValue(item);
                                    setExpenseType(item);
                                }}
                                size='small'
                            >
                                Edit
                            </Button>

                            <Button
                                type="link"
                                danger
                                size='small'
                                onClick={(e) => {
                                e.stopPropagation();
                                Modal.confirm({
                                    title: `Delete  Expense Type`,
                                    content: `Are you sure you want to delete ${item?.name}?`,
                                    okText: "Yes",
                                    cancelText: "No",
                                    onOk: () => {
                                    axios
                                        .delete(
                                        process.env.REACT_APP_API_URI +
                                            `/back/office/expsense/types/${item?.id}`,
                                        {
                                            headers: {
                                                authorization: `Bearer ${extractTokenFromUrl()}`,
                                            },
                                        }
                                        )
                                        .then(({ data }) => {
                                            message.success(data?.res);
                                            setExpenseTypes((prev) =>
                                                prev.filter((x) => x.id !== item.id)
                                            );
                                        })
                                        .catch((error) => requestError({ error }));
                                    },
                                });
                                }}
                                >
                                Delete
                            </Button>
                                    
                            </Col>
                        </Row>
                        ),
                        value: item?.id,
                        key: item?.id,
                    }))}

                  >
                </Select>
            </Form.Item>
          </Col>

            <Col span={12} >
                <Form.Item
                    style={{marginRight: 5}}
                    name={'currencyId'}
                    rules={[
                        { required: true, message: "Select Currency!" },
                    ]}
                    label = "Select Currency"
                    >
                        <Select
                        showSearch
                        onChange={(value)=>setState({ ...state, currencyId : value })}
                        value={state?.currencyId}
                        placeholder="Select Currency"
                        optionFilterProp="children"
                        filterOption={(input, option) => option.children.includes(input)}
                        >
                            {
                                currencies.map(item =>
                                <Option value={item.id} key={item.id}>{item.name}</Option>
                                )
                            }
                        </Select>
                    </Form.Item>
            </Col>

          <Col span={12}  >
            <Form.Item 
            style={{marginRight: 5}} name={'amount'} label = "Enter amount" 
            rules={[
              { required: true, message: "Enter amount" },
            ]}
            >
                <Input placeholder="Amount" />
            </Form.Item>
            </Col>
            

            <Col  span={24}>
                <Form.Item  
                    name={'notes'}
                    label={ "Notes(Brief description)" }
                >
                    <Input placeholder='Notes(Brief description)'/>
                </Form.Item>
            </Col>

        </Row>
        </Form>
        
      </Modal>
    </>
  );
};

export default BackOfficeExpenseModal;